export const PAYOUT_ACTION_TYPE = {
	requestPayout: "requestPayout",
	requestPayoutIdle: "requestPayoutIdle",
	getPayout: "getPayout",
	getPayoutIdle: "getPayoutIdle",
	balance: "balance",
	balanceIdle: "balanceIdle",
	checkBalanceIdle:"checkBalanceIdle",
	checkBalance:'checkBalance'
};
